import React from 'react';
import { useNavigate } from 'react-router-dom';

export function CTASection() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    setTimeout(() => {
      const input = document.querySelector('#url-input');
      if (input) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.classList.add('pulse-animation');
        setTimeout(() => {
          input.classList.remove('pulse-animation');
        }, 2000);
      }
    }, 100);
  };

  return (
    <section className="py-24 px-4 text-center">
      <h2 className="text-5xl font-medium mb-6">
        Let's make your conversion headline.
      </h2>
      <p className="text-3xl mb-12">
        Insert a link to your site and get your new 4U header.
      </p>
      <button 
        onClick={handleClick}
        className="inline-block border-2 border-black text-3xl px-12 py-4 rounded-full hover:bg-black hover:text-white transition-colors duration-300"
      >
        Try For Free
      </button>
    </section>
  );
}